<div class="block-header">
  Document List
</div>

<div class="attachemnts">
  <table mat-table [dataSource]="dataSource" matSort class="report-table">
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let item">{{ item.description ?? 'No description' }}</td>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
      <td mat-cell *matCellDef="let item">{{ item.fileName }}</td>
    </ng-container>

    <ng-container matColumnDef="preview">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Preview</th>
      <td mat-cell *matCellDef="let item">
        <a class="blue-link" (click)="preview(item.blobName)">Preview</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Download</th>
      <td mat-cell *matCellDef="let item">
        <a class="blue-link" (click)="download(item.blobName)">Download</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="no-data" *matNoDataRow>
      <td class="text-center" [attr.colspan]="displayedColumns.length">
        No Record found
      </td>
    </tr>
  </table>
</div>
